import { useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";

export const PageMeta = ({ title, description, titleAr, descriptionAr }) => {
  const { isAr } = useLanguage();
  useEffect(() => {
    document.title = isAr && titleAr ? titleAr : title;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", isAr && descriptionAr ? descriptionAr : description);
  }, [title, description, titleAr, descriptionAr, isAr]);
  return null;
};
